import RestService from "./restService";
import { CHANNEL_TYPE } from "../../url/hiring";
const singleton = Symbol();
const singletonEnforcer = Symbol();
/**
 *
 */
class ChannelTypeService extends RestService {
  constructor(enforcer) {
    super(CHANNEL_TYPE);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct Agency RestService more than one");
  }
  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new ChannelTypeService(singletonEnforcer);
    }
    return this[singleton];
  }
}

export default ChannelTypeService;
